import { Component, input } from '@angular/core';

import { ProgressType } from './progress.model';

/**
 * @module ApProgressModule
 *
 * @ngdoc component
 * @name ApProgressComponent
 *
 * @description A bar to show the progress in percentage
 */
@Component({
    selector: 'ap-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.scss']
})
export class ApProgressComponent {
    /**
     * Descriptive label of progress bar
     */
    public readonly label = input<string>();

    /**
     * Percentage of progress
     * Defaults to 0
     */
    public readonly progress = input(0);

    /**
     * Should the progress bar be small? Width 60px?
     * Defaults to false
     */
    public readonly small = input(false);

    /**
     * Maximum value of progress bar
     * Defaults to 100
     */
    public readonly max = input(100);

    /**
     * The visual representation
     * Defaults to BAR
     */
    public readonly type = input<ProgressType>(ProgressType.BAR);

    protected get typeClassName(): string {
        return `ap-progress--type-${this.type().toLowerCase()}`;
    }

    protected get percentage(): string {
        return Math.min(Math.max((this.progress() / this.max()) * 100, 0), 100).toFixed();
    }
}
